import React, { createContext, useState } from "react";

const initialState = [];

export const PopupContext = createContext([[], {}]);

let _dispatchers = { openPopup: () => {} };

let _getter = {};

export const getPopupDispatchers = () => _dispatchers;

export const getPopupState = () => _getter;

export function PopupContextProvider({ children }) {
  const [state, setState] = useState(initialState);

  const openPopup = (popup, params = {}, options = {}) => {
    const currentPopup = {
      params,
      type: popup,
      options: options || {},
    };

    setState((oldState) => {
      if (!options.stack) return [currentPopup];

      const lastPopup = oldState[oldState.length - 1];
      const newState = [...oldState];

      if (lastPopup?.type === currentPopup.type) newState.pop();

      return [...newState, currentPopup];
    });
  };


  const closePopup = () =>
    setState((oldState) => {
      const lastPopup = oldState[oldState.length - 1];
      if (!lastPopup?.options.stack) return [];

      const newState = [...oldState];
      newState.pop();
      return newState;
    });

  const closePopupByType = (type) => {
    setState((oldState) => oldState.filter((popup) => popup.type !== type));
  };

  _dispatchers = { openPopup, closePopup, closePopupByType };
  _getter = state;

  return (
    <PopupContext.Provider value={[{ openPopup, closePopup, closePopupByType }, state]}>
      {children}
    </PopupContext.Provider>
  );
}
